// extracted by mini-css-extract-plugin
export var container = "BenefitCard-module--container--1Ddjx";
export var info = "BenefitCard-module--info--1JcNi";
export var overlay = "BenefitCard-module--overlay--5EEfT";
export var imageContainer = "BenefitCard-module--imageContainer--1eGOj";